import {createTypes, async} from 'redux-action-creator'

export default createTypes(
  [
    'SET_EMAIL',
    ...async('SAVE'),
  ],
  'PROFILE/CHANGE_EMAIL/',
)



// WEBPACK FOOTER //
// ./src/sections/profile/types/changeEmail.js